import React from "react";
import "./statistics-card.scss";
import CardPanel from "../card-panel/card-panel";
import CardPanelHeader from "../card-panel/card-panel-header";
import CardPanelBody from "../card-panel/card-panel-body";
import ChartJsChart from "../chartJs/chart";
import { PulseLoader } from "react-spinners";
import noDataAvailable from "../../../assets/img/no_data_found_dashboard.png"

function StatisticsCard({containerCountMonth, setContainerCountMonth, contCountData, containerItem, containerCountNoData, containerCountLoader}) {
	
	const data = {
		labels: [
			"Booked",
			"Not Booked",
			"Sent for approval",
			"Cancelled",
      "Hold",
			"Approval Pending",
		],
		datasets: [
			{
				label: "Container",
				data: [containerItem["Booked"], containerItem["Not Booked"], containerItem["Sent for approval"], containerItem["Cancelled"],containerItem["Hold"], containerItem["Approval Pending"]],
				backgroundColor: [
					"Blue",
					"#4A3AFF",
					"#2D5BFF",
					"#93AAFD",
          "#E5EAFC",
					"#C6D2FD",
				],

				borderWidth: 1,
			},
		],
	};

	function containerChangeHandler(e) {
		setContainerCountMonth(e.target.value)
	}
	function showNoDataImage() {
		if(containerItem["Booked"] === undefined && containerItem["Not Booked"] === undefined && containerItem["Hold"] === undefined && containerItem["Sent for approval"] === undefined  && containerItem["Cancelled"] === undefined  && containerItem["Approval Pending"] === undefined  ){
			return false
		}else{
			return true
		}
	}

  return (
    <CardPanel>
      <CardPanelHeader title={containerItem.DataOf} subtitle="Container Count" bold customClass = "action-area-container-count">
        <input
          type="month"
          value={containerCountMonth}
          name="month"
          className="newDashboard_monthClass"
          onChange={containerChangeHandler}
        />
      </CardPanelHeader>
      <CardPanelBody>
        <div className="statistics-row">
          <div className="statistics-left">
            {showNoDataImage() && (
              <ChartJsChart chartType="pieChart" data={data} />
            )}
          </div>
          <div className="statistics-right">
            <ul className="chart-options">
              {showNoDataImage() &&
                data?.labels?.map((item, index) => {
                  return (
                    <li>
                      <span
                        className="bullets"
                        style={{
                          backgroundColor:
                            data.datasets[0].backgroundColor[index],
                        }}
                      ></span>
                      <span className="label">{item}</span>
                      <span className="value">
                        {containerItem[item] ? containerItem[item] : 0}
                      </span>
                      <span>
                        {" "}
                        {containerItem[item + " Percentage"]
                          ? Math.round(containerItem[item + " Percentage"]) +
                            "%"
                          : 0 + "%"}{" "}
                      </span>
                    </li>
                  );
                })}
              {!showNoDataImage() && !containerCountLoader && (
                <img
                  src={noDataAvailable}
                  alt="notAvailableImg"
                  className="noDataFoundImg"
                  style={{ width: "60%", marginLeft:"auto",marginTop:"90px", transform:"scale(1.5)" }}
                />
              )}
              {!showNoDataImage() && containerCountLoader && (
                <PulseLoader
                  color="#007bff"
                  size="20px"
                  margin="10px"
                  style={{ position: "relative", top: "0vh", left: "25%" }}
                />
              )}
            </ul>
          </div>
        </div>
      </CardPanelBody>
    </CardPanel>
  );
}

export default StatisticsCard;
